module.exports = "/_next/static/images/a1c3022d94a9e485a5182bed0f66c2bc-cards-right-small.jpg";